

// import React, { useState, useEffect, useCallback } from 'react';
// import '../styles/ManageEmployee.css';
// import MyProfile from './MyProfile';

// const ManageEmployee = () => {
//   const [employees, setEmployees] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState('');

//   // 🔥 EXISTING STATES
//   const [selectedEmployee, setSelectedEmployee] = useState(null);
//   const [isEditing, setIsEditing] = useState(false);



//   // ==========================
//   // 1. FETCH EMPLOYEES
//   // ==========================
//   const fetchEmployees = useCallback(async () => {
//     setLoading(true);
//     try {
//       const response = await fetch('/gt-api/get_employees.php', {
//         credentials: "include"
//       });
//       const data = await response.json();

//       if (data.success) {
//         setEmployees(data.employees);
//       } else {
//         console.error("Backend Error:", data.message);
//       }
//     } catch (error) {
//       console.error("Fetch Error:", error);
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   useEffect(() => {
//     fetchEmployees();
//   }, [fetchEmployees]);

//   // ==========================
//   // 2. DELETE (STEP 1)
//   // ==========================
//   const handleDelete = async (id) => {

//     const confirmDelete = window.confirm(
//       "ARE_YOU_SURE? This will permanently remove the employee."
//     );

//     if (!confirmDelete) return;

//     const password = window.prompt(
//       "Enter your Password or Master Password to confirm deletion:"
//     );

//     if (!password) return;

//     try {

//       const authResponse = await fetch(
//         "/gt-api/verify_delete_password.php",
//         {
//           method: "POST",
//           credentials: "include",
//           headers: {
//             "Content-Type": "application/json"
//           },
//           body: JSON.stringify({
//             password
//           })
//         }
//       );

//       const authData = await authResponse.json();

//       if (!authData.success) {
//         alert("Invalid Password");
//         return;
//       }

//       const response = await fetch(
//         '/gt-api/delete_employee.php',
//         {
//           method: 'POST',
//           credentials: "include",
//           headers: {
//             'Content-Type': 'application/json'
//           },
//           body: JSON.stringify({ id })
//         }
//       );

//       const result = await response.json();

//       if (result.success) {
//         alert("Employee deleted successfully");
//         fetchEmployees();
//       } else {
//         alert(result.message);
//       }

//     } catch (error) {
//       console.error(error);
//       alert("Connection error during deletion");
//     }
//   };
//   // ==========================
//   // 4. VIEW PROFILE
//   // ==========================
//   const handleViewEmployee = (emp) => {
//     console.log("SELECTED EMP:", emp);

//     setSelectedEmployee({
//       ...emp,
//       firstName: emp.FirstName,
//       lastName: emp.LastName,
//       email: emp.EmailId,
//       phone: emp.Phonenumber,
//       gender: emp.Gender,
//       dob: emp.Dob,
//       city: emp.City,
//       address: emp.Address,
//       local_address: emp.LocalAddress,
//       country: emp.Country,
//       profileImage: emp.ProfilePicture
//     });

//     setIsEditing(false);
//   };

//   // ==========================
//   // 5. FILTER
//   // ==========================
//   const filteredEmployees = employees.filter(emp =>
//     (emp.FirstName + " " + emp.LastName)
//       .toLowerCase()
//       .includes(searchTerm.toLowerCase()) ||
//     emp.empid.toString().toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   // ==========================
//   // PROFILE VIEW
//   // ==========================
//   if (selectedEmployee) {
//     return (
//       <div className="module-glass-card animate-fade">
//         <button
//           className="btn-action"
//           onClick={() => setSelectedEmployee(null)}
//           style={{ marginBottom: "15px" }}
//         >
//           ⬅ BACK TO EMPLOYEES
//         </button>

//         <MyProfile
//           userData={selectedEmployee}
//           setUserData={setSelectedEmployee}
//           isEditing={isEditing}
//           setIsEditing={setIsEditing}
//         />
//       </div>
//     );
//   }

//   // ==========================
//   // LOADING
//   // ==========================
//   if (loading) {
//     return <div className="loading-container">ACCESSING_DATABASE...</div>;
//   }

//   // ==========================
//   // TABLE VIEW
//   // ==========================
//   return (
//     <div className="module-glass-card animate-fade">
//       <div className="card-header-flex">
//         <div className="title-group">
//           <span className="pulse-icon">👥</span>
//           <h3>EMPLOYEE_DIRECTORY_CONTROL</h3>
//         </div>

//         <div className="search-container">
//           <input
//             type="text"
//             placeholder="Search by ID or Name..."
//             className="cyber-search"
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//           />
//         </div>
//       </div>

//       {/* Desktop Table */}
//       <div className="table-responsive-wrapper desktop-view">
//         <table className="cyber-table">
//           <thead>
//             <tr>
//               <th>USER_IDENTITY</th>
//               <th>DEPARTMENT</th>
//               <th>ACCESS_LEVEL</th>
//               <th>STATUS</th>
//               <th>OPERATIONS</th>
//             </tr>
//           </thead>

//           <tbody>
//             {filteredEmployees.map(emp => (
//               <tr key={emp.id}>
//                 <td>
//                   <div className="emp-info">
//                     <span
//                       className="emp-name clickable"
//                       onClick={() => handleViewEmployee(emp)}
//                     >
//                       {emp.FirstName} {emp.LastName}
//                     </span>
//                     <span className="emp-id-tag">{emp.empid}</span>
//                   </div>
//                 </td>

//                 <td>{emp.Department}</td>

//                 <td>
//                   <span className="role-pill">{emp.Role}</span>
//                 </td>

//                 <td>
//                   <span className={`status-dot ${emp.Status === '1' ? 'active' : 'inactive'}`}>
//                     {emp.Status === '1' ? 'Active' : 'Disabled'}
//                   </span>
//                 </td>

//                 <td className="action-buttons-cell">
//                   <button
//                     className="btn-action reject-cancel"
//                     onClick={() => handleDelete(emp.id)}
//                   >
//                     DELETE
//                   </button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>

//       {/* Mobile Cards */}
//       <div className="mobile-employee-list">
//         {filteredEmployees.map(emp => (
//           <div className="mobile-employee-card" key={emp.id}>

//             <div
//               className="mobile-employee-name"
//               onClick={() => handleViewEmployee(emp)}
//             >
//               {emp.FirstName} {emp.LastName}
//             </div>

//             <div className="mobile-row">
//               <span>ID</span>
//               <span>{emp.empid}</span>
//             </div>

//             <div className="mobile-row">
//               <span>Department</span>
//               <span>{emp.Department}</span>
//             </div>

//             <div className="mobile-row">
//               <span>Role</span>
//               <span>{emp.Role}</span>
//             </div>

//             <div className="mobile-row">
//               <span>Status</span>
//               <span>{emp.Status === "1" ? "Active" : "Disabled"}</span>
//             </div>

//             <button
//               className="btn-action reject-cancel mobile-delete-btn"
//               onClick={() => handleDelete(emp.id)}
//             >
//               DELETE
//             </button>

//           </div>
//         ))}
//       </div>

//     </div>
//   );
// };

// export default ManageEmployee;

























import React, { useState, useEffect, useCallback } from 'react';
import '../styles/ManageEmployee.css';
import MyProfile from './MyProfile';

const ManageEmployee = () => {
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  // 🔥 EXISTING STATES
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [isEditing, setIsEditing] = useState(false);



  // ==========================
  // 1. FETCH EMPLOYEES
  // ==========================
  const fetchEmployees = useCallback(async () => {
    setLoading(true);
    try {
      const response = await fetch('/gt-api/get_employees.php', {
        credentials: "include"
      });
      const data = await response.json();

      if (data.success) {
        setEmployees(data.employees);
      } else {
        console.error("Backend Error:", data.message);
      }
    } catch (error) {
      console.error("Fetch Error:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchEmployees();
  }, [fetchEmployees]);

  // ==========================
  // 2. DELETE (STEP 1)
  // ==========================
  const handleDelete = async (id) => {

    const confirmDelete = window.confirm(
      "ARE_YOU_SURE? This will permanently remove the employee."
    );

    if (!confirmDelete) return;

    const password = window.prompt(
      "Enter your Password or Master Password to confirm deletion:"
    );

    if (!password) return;

    try {

      const authResponse = await fetch(
        "/gt-api/verify_delete_password.php",
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            password
          })
        }
      );

      const authData = await authResponse.json();

      if (!authData.success) {
        alert("Invalid Password");
        return;
      }

      const response = await fetch(
        '/gt-api/delete_employee.php',
        {
          method: 'POST',
          credentials: "include",
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ id })
        }
      );

      const result = await response.json();

      if (result.success) {
        alert("Employee deleted successfully");
        fetchEmployees();
      } else {
        alert(result.message);
      }

    } catch (error) {
      console.error(error);
      alert("Connection error during deletion");
    }
  };
  // ==========================
  // 4. VIEW PROFILE
  // ==========================
  const handleViewEmployee = async (emp) => {
    console.log("SELECTED EMP:", emp);

    const empId = emp.id || emp.EmpId || emp.empid;

    const initialData = {
      ...emp,
      id: empId,
      EmpId: emp.EmpId || emp.empid,
      firstName: emp.FirstName || emp.firstName || "",
      FirstName: emp.FirstName || emp.firstName || "",
      lastName: emp.LastName || emp.lastName || "",
      LastName: emp.LastName || emp.lastName || "",
      email: emp.EmailId || emp.email || "",
      EmailId: emp.EmailId || emp.email || "",
      Department: emp.DepartmentName || emp.Department || emp.department || "",
      phone: emp.Phonenumber || emp.phone || emp.phonenumber || emp.MobileNumber || "",
      Phonenumber: emp.Phonenumber || emp.phone || emp.phonenumber || emp.MobileNumber || "",
      gender: emp.Gender || emp.gender || "",
      Gender: emp.Gender || emp.gender || "",
      dob: emp.Dob || emp.dob || "",
      Dob: emp.Dob || emp.dob || "",
      city: emp.City || emp.city || "",
      City: emp.City || emp.city || "",
      address: emp.Address || emp.address || "",
      Address: emp.Address || emp.address || "",
      local_address: emp.LocalAddress || emp.local_address || emp.Localaddress || "",
      LocalAddress: emp.LocalAddress || emp.local_address || emp.Localaddress || "",
      country: emp.Country || emp.country || "",
      Country: emp.Country || emp.country || "",
      profileImage: emp.ProfilePicture || emp.profileImage || null
    };

    setSelectedEmployee(initialData);
    setIsEditing(false);

    if (empId) {
      try {
        const res = await fetch(`/gt-api/get_profile.php?id=${empId}`, {
          credentials: "include"
        });
        const data = await res.json();
        if (data.success && data.employee) {
          const fresh = data.employee;
          setSelectedEmployee({
            ...fresh,
            id: fresh.id || fresh.EmpId || empId,
            EmpId: fresh.EmpId || fresh.empid || empId,
            firstName: fresh.FirstName || fresh.firstName || initialData.firstName,
            FirstName: fresh.FirstName || fresh.firstName || initialData.FirstName,
            lastName: fresh.LastName || fresh.lastName || initialData.lastName,
            LastName: fresh.LastName || fresh.lastName || initialData.LastName,
            email: fresh.EmailId || fresh.email || initialData.email,
            EmailId: fresh.EmailId || fresh.email || initialData.EmailId,
            Department: fresh.DepartmentName || fresh.Department || initialData.Department,
            phone: fresh.Phonenumber || fresh.phone || fresh.phonenumber || initialData.phone,
            Phonenumber: fresh.Phonenumber || fresh.phone || fresh.phonenumber || initialData.Phonenumber,
            gender: fresh.Gender || fresh.gender || initialData.gender,
            Gender: fresh.Gender || fresh.gender || initialData.Gender,
            dob: fresh.Dob || fresh.dob || initialData.dob,
            Dob: fresh.Dob || fresh.dob || initialData.Dob,
            city: fresh.City || fresh.city || initialData.city,
            City: fresh.City || fresh.city || initialData.City,
            address: fresh.Address || fresh.address || initialData.address,
            Address: fresh.Address || fresh.address || initialData.Address,
            local_address: fresh.LocalAddress || fresh.local_address || initialData.local_address,
            LocalAddress: fresh.LocalAddress || fresh.local_address || initialData.LocalAddress,
            country: fresh.Country || fresh.country || initialData.country,
            Country: fresh.Country || fresh.country || initialData.Country,
            profileImage: fresh.ProfilePicture || fresh.profileImage || initialData.profileImage
          });
        }
      } catch (err) {
        console.error("Fetch full employee profile error:", err);
      }
    }
  };

  // ==========================
  // 5. FILTER
  // ==========================
  const filteredEmployees = employees.filter(emp =>
    (emp.FirstName + " " + emp.LastName)
      .toLowerCase()
      .includes(searchTerm.toLowerCase()) ||
    emp.empid.toString().toLowerCase().includes(searchTerm.toLowerCase())
  );

  // ==========================
  // PROFILE VIEW
  // ==========================
  if (selectedEmployee) {
    return (
      <div className="module-glass-card animate-fade">
        <button
          className="btn-action"
          onClick={() => setSelectedEmployee(null)}
          style={{ marginBottom: "15px" }}
        >
          ⬅ BACK TO EMPLOYEES
        </button>

        <MyProfile
          userData={selectedEmployee}
          setUserData={setSelectedEmployee}
          isEditing={isEditing}
          setIsEditing={setIsEditing}
          isManagementView={true}
        />
      </div>
    );
  }

  // ==========================
  // LOADING
  // ==========================
  if (loading) {
    return <div className="loading-container">ACCESSING_DATABASE...</div>;
  }

  // ==========================
  // TABLE VIEW
  // ==========================
  return (
    <div className="module-glass-card animate-fade">
      <div className="card-header-flex">
        <div className="title-group">
          <span className="pulse-icon">👥</span>
          <h3>EMPLOYEE_DIRECTORY_CONTROL</h3>
        </div>

        <div className="search-container">
          <input
            type="text"
            placeholder="Search by ID or Name..."
            className="cyber-search"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>

      {/* Desktop Table */}
      <div className="table-responsive-wrapper desktop-view">
        <table className="cyber-table">
          <thead>
            <tr>
              <th>USER_IDENTITY</th>
              <th>DEPARTMENT</th>
              <th>ACCESS_LEVEL</th>
              <th>STATUS</th>
              <th>OPERATIONS</th>
            </tr>
          </thead>

          <tbody>
            {filteredEmployees.map(emp => (
              <tr key={emp.id}>
                <td>
                  <div className="emp-info">
                    <span
                      className="emp-name clickable"
                      onClick={() => handleViewEmployee(emp)}
                    >
                      {emp.FirstName} {emp.LastName}
                    </span>
                    <span className="emp-id-tag">{emp.empid}</span>
                  </div>
                </td>

                <td>{emp.Department}</td>

                <td>
                  <span className="role-pill">{emp.Role}</span>
                </td>

                <td>
                  <span className={`status-dot ${emp.Status === '1' ? 'active' : 'inactive'}`}>
                    {emp.Status === '1' ? 'Active' : 'Disabled'}
                  </span>
                </td>

                <td className="action-buttons-cell">
                  <button
                    className="btn-action reject-cancel"
                    onClick={() => handleDelete(emp.id)}
                  >
                    DELETE
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile Cards */}
      <div className="mobile-employee-list">
        {filteredEmployees.map(emp => (
          <div className="mobile-employee-card" key={emp.id}>

            <div
              className="mobile-employee-name"
              onClick={() => handleViewEmployee(emp)}
            >
              {emp.FirstName} {emp.LastName}
            </div>

            <div className="mobile-row">
              <span>ID</span>
              <span>{emp.empid}</span>
            </div>

            <div className="mobile-row">
              <span>Department</span>
              <span>{emp.Department}</span>
            </div>

            <div className="mobile-row">
              <span>Role</span>
              <span>{emp.Role}</span>
            </div>

            <div className="mobile-row">
              <span>Status</span>
              <span>{emp.Status === "1" ? "Active" : "Disabled"}</span>
            </div>

            <button
              className="btn-action reject-cancel mobile-delete-btn"
              onClick={() => handleDelete(emp.id)}
            >
              DELETE
            </button>

          </div>
        ))}
      </div>

    </div>
  );
};

export default ManageEmployee;